<template>
  <div>
    <md-progress-bar md-mode="indeterminate" v-if="fetching" />

    <md-list>
      <md-subheader>Settings</md-subheader>

      <md-list-item>
        <md-field>
          <md-icon>today</md-icon>
          <label>Daily target (hours)</label>
          <md-input type="number" v-model.number="models.dailyTarget" v-on:change="updateDailyTarget"></md-input>
        </md-field>
      </md-list-item>

      <md-list-item>
        <md-field>
          <md-icon>timelapse</md-icon>
          <label>Focus Duration (minutes)</label>
          <md-input type="number" v-model.number="models.focusDuration" v-on:change="updateFocusDuration"></md-input>
        </md-field>
      </md-list-item>

      <md-list-item>
        <md-field>
          <md-icon>timelapse</md-icon>
          <label>Short Break Duration (minutes)</label>
          <md-input type="number" v-model.number="models.shortBreakDuration" v-on:change="updateShortBreakDuration"></md-input>
        </md-field>
      </md-list-item>

      <md-list-item>
        <md-field>
          <md-icon>timelapse</md-icon>
          <label>Long Break Duration (minutes)</label>
          <md-input type="number" v-model.number="models.longBreakDuration" v-on:change="updateLongBreakDuration"></md-input>
        </md-field>
      </md-list-item>
    </md-list>

    <md-snackbar :md-active.sync="settingsSaved" :md-duration="4000" md-persistent>The settings was saved with success!</md-snackbar>
  </div>
</template>

<script>
import { db, auth } from '../main'
import { store } from "../store";
// import firebase from '@firebase/app'
// import * as firebaseui from 'firebaseui'

export default {
  name: 'Settings',
  data: function (){
    return {
      fetching: false,
      models: {
        dailyTarget: store.state.dailyTarget,
        focusDuration: store.state.pomodoro.focusDuration / Number(process.env.VUE_APP_TIME_UNIT),
        shortBreakDuration: store.state.pomodoro.shortBreakDuration / Number(process.env.VUE_APP_TIME_UNIT),
        longBreakDuration: store.state.pomodoro.longBreakDuration / Number(process.env.VUE_APP_TIME_UNIT)
      },
      settingsSaved: false
    };
  },
  methods: {
    updateDailyTarget: function () {
      this.getSettings().update({
        dailyTarget: this.models.dailyTarget
      }).then(() => {
        store.setDailyTarget(this.models.dailyTarget);

        this.$ga.event('Engagement', 'Updated Setting', 'Daily Target', this.models.dailyTarget);

        this.settingsSaved = true;
      });
    },
    updateFocusDuration: function () {
      this.getSettings().update({
        focusDuration: this.models.focusDuration
      }).then(() => {
        store.setFocusDuration(this.models.focusDuration * Number(process.env.VUE_APP_TIME_UNIT));

        this.$ga.event('Engagement', 'Updated Setting', 'Focus Duration', this.models.focusDuration);

        this.settingsSaved = true;
      });
    },

    updateShortBreakDuration: function () {
      this.getSettings().update({
        shortBreakDuration: this.models.shortBreakDuration
      }).then(() => {
        store.setFocusDuration(this.models.shortBreakDuration * Number(process.env.VUE_APP_TIME_UNIT));

        this.$ga.event('Engagement', 'Updated Setting', 'Short Break Duration', this.models.shortBreakDuration);

        this.settingsSaved = true;
      });
    },

    updateLongBreakDuration: function () {
      this.getSettings().update({
        longBreakDuration: this.models.longBreakDuration
      }).then(() => {
        store.setFocusDuration(this.models.longBreakDuration * Number(process.env.VUE_APP_TIME_UNIT));

        this.$ga.event('Engagement', 'Updated Setting', 'Long Break Duration', this.models.longBreakDuration);

        this.settingsSaved = true;
      });
    },

    getSettings: function () {
      return db.collection('settings').doc(auth.currentUser.uid);
    }
  },
  mounted: function () {
    this.$ga.page('/settings');
  }
}
</script>

<style>

</style>
